// ユーザー管理ページ（React）
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

// const API_URL = 'http://localhost:8000/api/users'; // FastAPI側のURLに合わせて
// const Select_API_URL = 'http://127.0.0.1:8000/api/select_user'; // FastAPI側のURLに合わせて
const Select_API_URL = '/api/select_user'; // FastAPI側のURLに合わせて
// const Regist_API_URL = 'http://127.0.0.1:8000/api/add_user'; // FastAPI側のURLに合わせて
const Regist_API_URL = '/api/add_user'; // FastAPI側のURLに合わせて
// const Delete_API_URL = 'http://127.0.0.1:8000/api/delete_user'; // FastAPI側のURLに合わせて
const Delete_API_URL = '/api/delete_user'; // FastAPI側のURLに合わせて

function UserManagementPage() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: '', username: '', password: '' });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await axios.get(Select_API_URL);
    console.log(res.data.items);
    setUsers(res.data.items);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    const payload = {
      ...form,
      user_id: Number(form.user_id), // 👈 数値に変換して送る
    };
    await axios.post(Regist_API_URL, payload);
    console.log(form);
    // setForm({ email: '', username: '', password: '' });
    fetchUsers();
  };

  const handleDelete = async (email) => {
    await axios.get(`${Delete_API_URL}?email=${email}`);
    fetchUsers();
  };

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        ユーザー管理
      </Typography>

      <Box mb={3} display="flex" gap={2}>
        <TextField
          label="user_id(数字)"
          name="user_id"
          value={form.user_id}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <TextField
          label="Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <TextField
          label="ユーザー名"
          name="username"
          value={form.username}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <TextField
          label="パスワード"
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <TextField
          label="サービス名"
          name="memo"
          type="memo"
          value={form.memo}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <TextField
          label="メモ(オプション)"
          name="service_name"
          type="service_name"
          value={form.service_name}
          onChange={handleChange}
          InputLabelProps={{ sx: { fontSize: '0.75rem' } }} // 👈 ここでサイズ指定
        />
        <Button variant="contained" onClick={handleRegister}>
          登録
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>ユーザー名</TableCell>
              <TableCell>サービス名</TableCell>
              <TableCell>メモ</TableCell>
              <TableCell>操作</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.id}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.username}</TableCell>
                <TableCell>{user.service_name}</TableCell>
                <TableCell>{user.sub_info}</TableCell>
                <TableCell>
                  <Button color="error" onClick={() => handleDelete(user.email)}>
                    削除
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default UserManagementPage;
